import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PasswordProtection } from '../../models';
import { SLICE_NAMES } from '../constants';

export const passwordProtectionInitialState: PasswordProtection = {
  addChallenge: false,
  blockBlockedPage: false,
  blockSettings: false,
  email: null,
  isEmailEditMode: false,
  isEmailProtectSent: false,
  isEmailVerified: false,
  isEmailVerifySent: false,
  notifyUninstall: false,
  pass: null,
};

const passwordProtectionSlice = createSlice({
  name: SLICE_NAMES.PASSWORD_PROTECTION,
  initialState: passwordProtectionInitialState,
  reducers: {
    setPasswordProtection: (
      state: PasswordProtection,
      action: PayloadAction<Partial<PasswordProtection>>
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setPasswordProtection } = passwordProtectionSlice.actions;

export const passwordProtectionReducer = passwordProtectionSlice.reducer;
